import { pb } from './pb';

// Public fetch for Agenda page
export async function fetchEventsPublic({ includePast = false } = {}){
  const nowIso = new Date().toISOString();
  const filterParts = ["published=true"];
  if(!includePast){
    // keep only events that end in the future or don't have end_at but start_at in the future
    filterParts.push(`(end_at = '' && start_at >= '${nowIso}') || (end_at != '' && end_at >= '${nowIso}')`);
  }
  const filter = filterParts.join(' && ');
  const res = await pb.collection('events').getList(1, 100, {
    filter,
    sort: 'order,start_at,title',
  });
  return res.items;
}

// Admin helpers
export async function fetchEventsAdmin(page = 1, perPage = 20, search = ''){
  const filters = [];
  if(search){
    const s = search.replace(/"/g, '\\"');
    filters.push(`title ~ "%${s}%" || description ~ "%${s}%" || location ~ "%${s}%"`);
  }
  const filter = filters.join(' && ');
  return pb.collection('events').getList(page, perPage, {
    filter,
    sort: 'order,start_at,title',
  });
}

export async function createEvent(data){
  return pb.collection('events').create(data);
}

export async function updateEvent(id, data){
  return pb.collection('events').update(id, data);
}

export async function deleteEvent(id){
  return pb.collection('events').delete(id);
}
